import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { VersetDuJourTextField, VersetDuJourModel } from '@core/models/bible/verset-du-jour-model';
import { BookService } from '@core/service/bible/book/book.service';
import { VersesService } from '@core/service/bible/verses/verses.service';
import { VersetDuJourService } from '@core/service/bible/verset-du-jour/verset-du-jour.service';
import { CommonService } from '@core/service/common/common.service';
import { GlobalService } from '@core/service/global.service';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { BreadcrumbButtonTopComponent } from '@shared/components/breadcrumb-button-top/breadcrumb-button-top.component';
import { ImportALlModule } from '@shared/imports';
import { EMPTY_GUID } from '@shared/tools/constants/constants';
import { MenuLink } from '@shared/tools/enums/enum-router';
import { keyValueYesNoList } from '@shared/tools/enums/enum-status.enum';
import { EnumText } from '@shared/tools/enums/enum-Text';
import { PermissionCode } from '@shared/tools/enums/permission';
import { Severity } from '@shared/tools/enums/severities';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-verset-du-jour-form',
  standalone: true,
  imports: [
    MessagesModule, ConfirmDialogModule, ToastModule, TabViewModule,TableModule,
    ImportALlModule,
    BreadcrumbButtonTopComponent,
  ],
  templateUrl: './verset-du-jour-form.component.html',
  styleUrl: './verset-du-jour-form.component.scss'
})
export class VersetDuJourFormComponent  extends UnsubscribeOnDestroyAdapter implements OnInit
{
//   this.objVersetDuJour.groupeChantantId = EnumGroupeChantant.CHANT_INTERNAUTE;
// }
//console.log(`NEW chantUser`,this.chantUser);
//this.groupeCu.code = uuid.v4();
  public textField=VersetDuJourTextField;
  loadingGroupeDataList = false;
  contenuStr = '';
  chapitreList: string[]=[];
  chapitreSelected: number|string=0;

  public objVersetDuJour: VersetDuJourModel = new VersetDuJourModel();
  public keyValueYesNoList = keyValueYesNoList;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    public messageService: MessageService,
    public bookService: BookService,
    public versesService: VersesService,
    public versetDuJourService: VersetDuJourService,
    public confirmationService: ConfirmationService,
    public globalService: GlobalService,
  ) {
      super();
      //this.userName = this.commonService.authorizationService.sessionAuthService.userConnected.userName;
  }

  ngOnInit(): void {
    //console.log('ngOnInit:',this.chantUser);
    this.activatedRoute.params.subscribe((params: Params) => {
      this.id = params['id'];
      console.log('Params:',params);
    });
    this.loadAllData();
  }
  get disabledBtnSaveChanges(): boolean{
    return this.formGroupPageName.invalid;
  }
  async loadAllData() {
    this.initForm();
    await this.bookService.loadAllData();
    await this.getPermission();
    await this.getOneById( this.id );
  }
  getChapitreList()
  {
    this.chapitreList=[];
    this.versesService.versesDataList=[];
    this.chapitreSelected=0;
    let data = this.bookService.bookDataList.find((x)=> x.osis == this.objVersetDuJour.bookOsis);
    if( data ){
      for (let index = 1; index <= data?.chapters; index++) {
        this.chapitreList.push(''+index)
      }
    }
  }

  async getVersesList() {
    await this.versesService.loadVersesByChapter(this.objVersetDuJour.bookOsis, this.chapitreSelected);
  }
  onSelectedVersesStyle(verse: any) {
    return this.objVersetDuJour.verset == verse? ' actif' : '';
  }

  async getPermission(){
    this.addButton = await this.commonService.authorizationService.hasPermission([PermissionCode.AddPermissions]);
    this.editButton = await this.commonService.authorizationService.hasPermission([PermissionCode.EditPermissions]);
    this.deleteButton = await this.commonService.authorizationService.hasPermission([PermissionCode.DeletePermissions]);
    this.addOrEditButton = this.isNew? this.addButton : this.editButton;
  }

  async getOneById(id: any ){
    let userName = this.commonService.authorizationService.userConnected.userName;
    this.isNew = ( this.id == '' || this.id == EMPTY_GUID );
    this.title = ((this.isNew) ? this.enumText.New : this.enumText.Edit) +' '+ this.textField.title

    if( !this.isNew ){
      this.globalService.showLoader();
      this.subs.sink = await this.versetDuJourService.getOne(id).subscribe({
        next:async (result)=> {
          this.objVersetDuJour = result;
          console.log(`objVersetDuJour`,this.objVersetDuJour);
          await this.getChapitreList();
          this.chapitreSelected=this.objVersetDuJour.versesData.chapitreReal;
          await this.getVersesList();
          this.globalService.showLoader(false);
        },
        complete(){},
        error: (ex)=>{
          console.log(`error`, ex);
          this.globalService.showLoader(false);
        }
      });
    }else{
        this.objVersetDuJour = new VersetDuJourModel();
        this.id = EMPTY_GUID;
        this.objVersetDuJour.id = EMPTY_GUID;
    }
  }

  onNew(){
    this.globalService.showLoader();
    this.isNew=false;
    this.id = EMPTY_GUID;
    this.objVersetDuJour.id = EMPTY_GUID;
    this.objVersetDuJour=new VersetDuJourModel();
    this.router.navigate([ MenuLink.VersetDuJour, this.id ]);
    this.globalService.showLoader(false);
  }
  initForm(){
    let formFields: any = {
      id: this.fb.control(this.objVersetDuJour.id),
      bookOsis: this.fb.control(this.objVersetDuJour.bookOsis, [Validators.required]),
      verset: this.fb.control(this.objVersetDuJour.verset, [Validators.required]),
      dateDeclancheur: this.fb.control(this.objVersetDuJour.dateDeclancheur, [Validators.required]),
      actifYN:this.fb.control(this.objVersetDuJour.actifYN ),
      chapitreSelected: this.fb.control(this.chapitreSelected ),
    };
    this.formGroupPageName = this.fb.group(formFields);
  }

  onClose(){
    this.router.navigate([ MenuLink.VersetDuJour ]);
  }

  onSubmit(): void {
    console.log('formGroupPageName:', this.formGroupPageName.value);
    //console.log('formGroupPageName.invalid:', this.formGroupPageName.invalid);
    this.clear();
    if (this.formGroupPageName.invalid) {
      return;
    }
    this.globalService.showLoader();
    let obj = this.formGroupPageName.value;


    console.log('formGroupPageName:obj::', obj);
    this.subs.sink = this.versetDuJourService.saves(this.isNew, obj ).subscribe({
      next: (result: any) => {
        console.log(`result:`,result);
        if( result ){
          this.messageService.add({severity:Severity.info, summary: this.textField.title, detail: EnumText.sauvegardeEffectuee});
          this.globalService.showLoader(false);
          this.onClose();
        }else{
          this.messageService.add({severity:Severity.error, summary: EnumText.error, detail: EnumText.msg_TraitementImpossible});
        }
      },
      error: (ex: any) => {
        console.log(`ERROR.::.`,ex);
        this.globalService.showLoader(false);
        //this.error = ex;
        this.messageService.add({severity:Severity.error, summary: EnumText.error, detail: EnumText.msg_TraitementImpossible});
      },
      complete: () => {
        //console.log(`COMPLETE.::.`);
         this.globalService.showLoader(false);
      }
    });
  }

  clear() {
      this.messageService.clear();
  }

  onError(error: any){
    console.log(error.message);
  }

}
